<template>
  <div class="editPrompt flex flex-col mt-4 mb-6">
    <div class="flex justify-between mb-4">
      <h1 class="text-left text-lg font-semibold text-primary-500 dark:text-primary-100">
        One more step...
      </h1>
    </div>
    <p class="text-left max-w-md">
      In order to subscribe to the <span class="font-semibold">{{ region.region_name }}</span> region, please select a permission set for {{ username ? username : 'the user' }}'s sites in said region.
    </p>
    <div class="w-full mt-4">
      <VDropdown
        :sel-option="selPermissionSet"
        :options="accessiblePermissionSets"
        :disabled="selectedHiddenSet && !hasAccessToHiddenPermissionSets"
        class="w-full"
        placeholder="Select permission set"
        @select="selectPermissionSet"
      />
    </div>
    <!-- POSSIBLE VALUES TO CHOOSE FROM -->
    <ul class="flex gap-1 mt-2 mb-6">
      <li v-for="(value, idx) of possibleValues" :key="idx">
        <button
          @click="selectPermissionSet(value)"
          class="rounded text-xs p-0.5 text-primary-700 dark:text-primary-50 font-medium bg-primary-5 hover:bg-primary-15 border border-gray-300 dark:border-gray-800 dark:bg-primarydark/30 dark:hover:bg-primarydark-400/50 dark:hover:text-white dark:border-primarydark/50 dark:shadow-primarydark/30 dark:hover:border-primary-50/30"
        >
          {{ value.name }}
          <font-awesome-icon v-if="getHiddenPermissionSetsObj[value.id]" icon="fa-solid fa-shield-halved" class="h-3 w-3 mx-0.5" />
        </button>
      </li>
    </ul>
    <!-- HIDDEN PERMISSION SET WARNING -->
    <div v-auto-animate="{ duration: 200 }">
      <div v-if="selectedHiddenSet" class="w-full lg:w-96 flex items-start text-sm text-left font-medium text-gray-500 dark:text-gray-400 pb-8">
        <font-awesome-icon icon="fa-solid fa-exclamation-circle" class="h-4 w-4 mt-1 mr-1.5" />
        <p>This is a <span class="italic">hidden</span> permission set. This will grant this user <span class="italic">advanced</span> privileges.</p>
      </div>
    </div>
    <section class="w-full flex flex-wrap sm:flex-nowrap mt-2 gap-y-2">
      <VButton
        label="Cancel"
        @click="closePrompt"
        size="sm"
        uppercase
        color="secondary"
        outlined
        class="w-full sm:w-1/2 sm:mr-1"
      />
      <VButton
        label="Next"
        @click="submit"
        :disabled="!selPermissionSet"
        icon="fa-solid fa-arrow-right-long"
        size="sm"
        uppercase
        color="primary"
        class="w-full sm:w-1/2 sm:ml-1"
      />
    </section>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import VDropdown from "@/components/Inputs/DropDown/VDropdown.vue"
import VButton from "@/components/Buttons/Button/VButton.vue"

export default {
  components: {
    VDropdown,
    VButton
  },
  data() {
    return {
      selPermissionSet: null,
      submitting: false,
      submittingAll: false,
      submittingNoPermissions: false,
      selectedHiddenSet: false
    }
  },
  computed: {
    ...mapGetters([
      "getProceedArgs",
      "getAllPermissionSets",
      "getPermissionSetsObj",
      "getNonHiddenPermissionSets",
      "getHiddenPermissionSets",
      "getHiddenPermissionSetsObj",
      "getEmployeesSitesEdited",
      "getIsTenantSuperuser",
      "getIsAdmin"
    ]),
    region() {
      return this.getProceedArgs?.region
    },
    username() {
      return this.getProceedArgs?.username
    },
    userID() {
      return this.getProceedArgs?.userID
    },
    hasAccessToHiddenPermissionSets() {
      return this.getIsTenantSuperuser || this.getIsAdmin
    },
    accessiblePermissionSets() {
      if (this.hasAccessToHiddenPermissionSets) return [ ...this.getHiddenPermissionSets, ...this.getNonHiddenPermissionSets ]
      return this.getNonHiddenPermissionSets
    },
    possibleValues() {
      return this.getProceedArgs?.suggestions
    },
  },
  methods: {
    ...mapMutations([
      "setProceedArgs",
      "closePrompt",
      "proceedPrompt",
    ]),
    submit() {
      if (this.selPermissionSet == null) {
        this.closePrompt()
        return
      }
      this.submitting = true
      this.proceedPrompt()
    },
    selectPermissionSet(option) {
      this.selPermissionSet = option
      this.setProceedArgs({
        ...this.getProceedArgs,
        editField: "permissions_set_id",
        editValue: option.id,
        permissionSetID: option.id,
        siteEmployees: Object.values(this.getEmployeesSitesEdited)
      })
      if (this.getHiddenPermissionSetsObj[option.id]) {
        this.selectedHiddenSet = true
      }
      else this.selectedHiddenSet = false
    },
  },
}
</script>

<style scoped>
.editPrompt {
  min-width: 18rem;
}
</style>